import {
  amber, grey, green, red, common,
} from '@mui/material/colors';

const colors = {
  white: common.white,
  background: grey[500],
  primary: '#1c2138',
  secondary: '#1c2138',
  positive: green[500],
  medium: amber[700],
  negative: red[500],
  neutral: grey[500],
  geometry: common.white,
  '#00eb00': '#00eb00',
  '#ff2828': '#ff2828',
  '#ffc41f': '#ffc41f',
  '#ffffff': '#ffffff',
  '#676767': '#676767',
};

const markerColors = {
  White: '#ffffff',
  Yellow: '#ffff00',
  Pink: '#ffc0cb',
  Orange: '#ffa500',
  Magenta: '#ff00ff',
  Red: '#ff0000',
  Silver: '#c0c0c0',
  Lightblue: '#add8e6',
  Brown: '#a52a2a',
  Grey: '#808080',
  Olive: '#808000',
  Purple: '#800080',
  Maroon: '#800000',
  Aquamarine: '#7fffd4',
  Cyan: '#00ffff',
  Lime: '#00ff00',
  Green: '#008000',
  Blue: '#0000ff',
  Darkblue: '#00008b',
  Black: '#000000',
};

const markerColorValues = ['#00eb00', '#ff2828', '#ffc41f', '#ffffff', '#676767'];

export default {
  background: {
    default: colors.white,
  },
  primary: {
    main: colors.primary,
  },
  secondary: {
    main: colors.secondary,
    contrastText: colors.white,
  },
  colors,
  markerColors,
  markerColorValues,
};
